module.exports = __webpack_public_path__ + "img/zxc1.77703ab0.jpeg";